// Exception: HOC that proxy down props
/* eslint-disable react/jsx-props-no-spreading */

import { FC, SVGProps } from 'react';

import classes from './Image.module.scss';

const QubitsImage: FC<SVGProps<SVGSVGElement>> = props => (
  // View box is shifted to the left, so the chip is exactly in the center.
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="-40 0 2000 2000" xmlSpace="preserve" {...props}>
    <path className={classes.st5} d="m1673.42 810.58-712.91 411.59-709.15-409.42 712.91-411.6z" />
    <path
      className={classes.st0}
      d="m1028.73 1142.88 8.09 4.68-.09 1.92-36.75 21.21-3.33.06-8.09-4.68m95.72-55.26 8.09 4.67-.09 1.93-36.75 21.21-3.33.05-8.09-4.67m95.72-55.26 8.09 4.67-.09 1.92-36.75 21.22-3.33.05-8.09-4.67m95.72-55.26 8.09 4.67-.09 1.92-36.75 21.22-3.33.05-8.09-4.67m151.26-87.33 8.1 4.67-.1 1.92-36.74 21.22-3.33.05-8.09-4.67M994.58 802.46l4.86 2.8-.09 1.92-36.75 21.22-3.33.05-4.86-2.8m102.3 12.68 1.62.93-.09 1.92-36.75 21.22-3.32.05-1.62-.93m-79.83 18.05-1.62-.93.1-1.92 36.74-21.22 3.33-.05 1.62.93m109 109.32 1.62.93-.09 1.92-52.13 30.1-3.33.05-1.61-.93M883.48 866.6l3.24 1.87-.09 1.92-36.75 21.21-3.33.06-3.23-1.87m89.05-123.25 10.52 6.07-.09 1.92-36.75 21.22-3.33.05-10.52-6.07m95.72-55.26 10.52 6.07-.09 1.92-36.75 21.22-3.33.05-10.52-6.07m-148.72-85.87-16.8-9.7.09-1.92 36.75-21.22 3.33-.05 16.8 9.7m15.38-8.88-16.8-9.7.09-1.92 47-27.14 22.03 4.82 3.23 1.87m188.89 62.67 10.51 6.08-.09 1.92-36.74 21.21-3.33.06-10.52-6.08m102.38 12.73 2.43 1.4-.09 1.92-36.75 21.22-3.33.05-2.43-1.4M910.75 563.6l13.75 7.94-.09 1.92-36.75 21.22-3.32.05-13.76-7.94M688.55 691.88l13.75 7.95-.09 1.92-36.74 21.21-3.33.06-13.76-7.95m206.82-119.4 5.66 3.27-.09 1.92-36.75 21.22-3.33.05-5.66-3.27m658.09 267.45 8.09 4.68-.09 1.92-36.75 21.21-3.32.06-8.09-4.68m-149.14-86.1-18.6-10.74.1-1.92 36.74-21.21 3.33-.06 18.59 10.74M972.35 643.57l-18.52-10.69.09-1.92 36.75-21.22 3.32-.05 18.52 10.69m516.16 233.86 8.09 4.67-.09 1.92-36.75 21.22-3.32.05-8.1-4.67m-84.69-95.28 2.42 1.4-.09 1.92-36.74 21.22-3.33.05-2.43-1.4m-462.19 310.44-2.42-1.4.09-1.92 36.75-21.22 3.32-.05 2.43 1.4m182.03-105.09-2.43-1.4.09-1.93 36.75-21.21 3.33-.05 2.43 1.4M752.38 726.76l2.43 1.4-.1 1.93-36.74 21.21-3.33.05-2.43-1.4m262.36-151.47 2.43 1.4-.09 1.92-36.75 21.22-3.32.05-2.43-1.4M694.6 803.93l-2.43-1.4.09-1.93 36.75-21.21 3.33-.05 2.43 1.4m15.38-8.88-2.43-1.41.09-1.92 36.75-21.21 3.33-.06 2.43 1.41m271.3 203.01-18.59-10.73.09-1.92 36.75-21.22 3.32-.05 18.6 10.73M506.68 697.4l-6.48-3.73.09-1.93 36.75-21.21 3.33-.05 6.47 3.73m743.46 217.07-2.43-1.4.09-1.92 36.75-21.22 3.33-.05 2.42 1.4m-93.3 10.28 2.43 1.4-.09 1.92-36.75 21.22-3.33.05-2.43-1.4M679.66 668.99l-2.43-1.4.09-1.93 36.75-21.21 3.32-.05 2.43 1.4m182.03-105.1-2.42-1.4.09-1.92 36.74-21.22 3.33-.05 2.43 1.4m141.42 61.92-2.42-1.4.09-1.92 36.75-21.22 3.32-.05 2.43 1.4m22.06 59.11-2.43-1.4.1-1.92 36.74-21.21 3.33-.06 2.43 1.4M1027.9 611.5l-2.43-1.4.09-1.92 36.75-21.22 3.32-.05 2.43 1.4m24.32 445.27 2.42 1.41-.09 1.92-52.13 30.09-3.32.06-2.43-1.4m-320.59-58.79-2.43-1.4.09-1.92 33.33-19.24 3.33-.06 2.42 1.41m79.7 26.28-2.42-1.41.09-1.92 36.75-21.21 3.32-.06 2.43 1.41M645.73 904l-2.43-1.4.09-1.93 36.75-21.21 3.33-.05 2.43 1.4m202.33 99.05-2.42-1.4.09-1.92 36.74-21.22 3.33-.05 2.43 1.4m-164.91-48.83-7.28-4.2.09-1.92 36.75-21.22 3.33-.05 7.28 4.2M515.57 720.3l14.56 8.41-.09 1.92-36.74 21.22-3.33.05-14.57-8.41m206.82-119.4 4.04 2.33-.09 1.92-36.75 21.22-3.32.05-4.05-2.33m399.19 100.21-7.29-4.21.1-1.92 36.74-21.21 3.33-.06 7.28 4.21M890.07 934.54l2.42 1.4-.09 1.93-36.74 21.21-3.33.05-2.43-1.4M647.94 858.9l5.67 3.27-.09 1.92-36.75 21.21-3.33.06-5.66-3.27M460.02 752.37l4.05 2.34-.09 1.92-36.75 21.21-3.33.06-4.05-2.34m921.67-29.37 9.71 5.61-.09 1.92-36.75 21.21-3.33.06-9.71-5.61m-7.06-68.22 3.24 1.87-1.31 10.1-36.75 21.22-17.49.75-3.24-1.87m-8.32 77.1 9.71 5.61-.09 1.92-36.75 21.22-3.33.05-9.71-5.61m-15.38 8.88 9.71 5.61-.09 1.92-36.75 21.22-3.32.05-9.71-5.61m-293.13 169.24 9.71 5.61-.09 1.92-36.75 21.22-3.33.05-9.71-5.61m218.43 61.97-1.62-.94.31-6.72-23.99-13.85-11.64.18-1.62-.93m205.2-73.96-1.62-.93.32-6.73-23.99-13.85-11.65.19-1.61-.94m205.2-73.95-1.62-.94.32-6.72-23.99-13.85-11.65.18-1.62-.93m-148.59-85.79-1.62-.94.32-6.72-23.77-13.72-11.65.18-1.61-.93m-104.04 132.36 2.42 1.4 17.78 28.02 2.43 1.4M676.67 986l2.43 1.4 17.62 27.94 2.42 1.4M545.56 846.17l2.43 1.4 17.7 27.98 2.43 1.4m88.54-94.93 2.43 1.41 17.7 27.98 2.43 1.4M961 893.59l2.43 1.4 18.09 28.21 2.43 1.4m261.85-123.15 2.43 1.4 17.78 28.03 2.42 1.4m-95.71 55.26-2.43-1.4-48.54-10.26-2.43-1.4m133.22-5 2.43 1.41 17.52 27.87 2.43 1.4m-42.76-234.87 2.43 1.4 17.62 27.94 2.43 1.4m-251.34 29.55 2.43 1.41 17.7 27.98 2.42 1.4m-50.5-301.52 2.42 1.4 17.37 27.79 2.43 1.4m279.51 269.92-2.43-1.4-48.86-10.44-2.43-1.41m-293.22 69.52-2.43-1.4-48.46-10.22-2.43-1.4m420.76 161.02-2.43-1.4-49.08-10.58-2.43-1.4m-344.77-88.53 2.42 1.4 17.62 27.93 2.43 1.41m-233.4-152.52-2.43-1.4-50.08-9.18-2.43-1.4m39.55 20.86-2.42-1.4-74.87 5.13-2.43-1.4m39.56 20.86-2.43-1.4-90.25 14.01-2.43-1.4m222.2-128.29 2.43 1.4 19.31 26.94 2.43 1.41m182.64-149.15 2.43 1.4-5.47 41.25 2.43 1.4m56.16-76.12 2.43 1.4-5.47 41.25 2.43 1.4M576.84 800.08l-2.43-1.4-50.08-9.18-2.43-1.4m-56.16 76.12-2.43-1.4-50.08-9.18-2.43-1.4m850.89-87.99-2.42-1.41-73.65 3.87-2.42-1.41m89.13-123.2 2.42 1.4-7.16 42.24 2.43 1.41m-350.99-56.6 2.42 1.4-7.08 42.29 2.43 1.4m420.95 260.8-2.43-1.4-73.87 3.73-2.43-1.4M585.73 822.98l2.43 1.4-7.09 42.29 2.43 1.4m802.51-32.05-2.42-1.4-73.07 4.2-2.43-1.41m-255.37 191.04-2.43-1.4-73.07 4.19-2.42-1.4m182.53-133.42-2.42-1.4-73.33 4.05-2.42-1.4M775.37 613.73l-2.43-1.41-72.91 4.29-2.43-1.41m217.16 205.31-2.43-1.4-73.25 4.09-2.43-1.4m-26.41 130.8-2.43-1.4-73.16 4.13-2.43-1.4m-77.6-27.04 2.43 1.41-7.08 42.29 2.42 1.4m477.9-347.75-2.43-1.41-73.26 4.09-2.43-1.4m507.77 182.64-2.42-1.41-73.87 3.74-2.43-1.41m38.56 22.27-2.43-1.41-89.25 12.62-2.43-1.4m-190.92 82.19-2.43-1.4-88.45 13.08-2.43-1.4m-10.51 122.21-2.42-1.4-104.64 21.5-2.42-1.4M1225.5 597.3l2.42 1.4-22.46 51.17 2.42 1.4M1072.1 829.45l2.42 1.4-22.07 51.4 2.43 1.4m-86.82 78.16 2.43 1.4-22.4 51.21 2.43 1.41M829.97 753.8l2.43 1.4-22.45 51.18 2.43 1.4m-86.83 78.16 2.43 1.4-22.47 51.17 2.43 1.41m86.41 49.88 2.43 1.41-22.07 51.4 2.42 1.4m126.73 26.78 2.43 1.41-22.65 51.06 2.43 1.4M457.46 797.27l-2.43-1.4-88.3 13.16-2.43-1.4m133.33-33.55-2.43-1.4-88.3 13.16-2.43-1.4m166.65-96.21 2.43 1.4-22.8 50.98 2.42 1.4m466.02-53.63-2.43-1.4-88.64 12.96-2.43-1.4m250.92-1.18 2.43 1.4-22.55 51.13 2.43 1.4M959.96 463.73l2.43 1.4-7.42 42.1 2.43 1.4m284.63 483.07-38.55-22.26m205.2-73.95-38.56-22.26m205.21-73.96-38.56-22.26m-25.08-14.48-37.76-21.8m-85.75-49.51-38.34-22.13m85.24 66.98-38.01-21.95m-2.16 45.14-38.01-21.95m100.05 57.76-37.76-21.8m-93.62-118.2-37.86-21.85m-135.37 50.12-37.94-21.9m-79.83 18.06-37.95-21.91m106.75 125.77-37.86-21.86m-17.69 53.93-37.86-21.86M825.62 943.72l-37.85-21.86m135.71-178.22-37.96-21.91m-24.27-14.02-37.94-21.9m-17.61 53.97-37.94-21.9m-103.49-40.01-37.6-21.71m192.37 219.61-37.94-21.9m-24.27-14.02-37.95-21.91m-17.6 53.99-37.95-21.92m475.66-302.65-37.93-21.91m-24.28-14.01-37.84-21.85m-95.16 458.2-38.33-22.13m-10.48 122.24-38.01-21.95m-219.95-45.08-37.94-21.9M386.53 838.23l-37.61-21.72m241.26 119.56-37.95-21.91m-24.28-14.02-37.94-21.9m-23.66-58.07 3.24 1.87 3.33-.05 32.99 19.04m462.51 311.44 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m976.33 1160.99 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 952.52 1172.428)"
      className={classes.st0}
      cx="952.49"
      cy="1172.88"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 952.52 1172.428)"
      className={classes.st0}
      cx="952.49"
      cy="1172.88"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m959.48 1164.18-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m960.59 1174.75-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m965.99 1168.83-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.33-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m913.5 1124.71 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 889.697 1136.173)"
      className={classes.st0}
      cx="889.66"
      cy="1136.61"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 889.697 1136.173)"
      className={classes.st0}
      cx="889.66"
      cy="1136.61"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m896.65 1127.9-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m897.76 1138.47-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m903.16 1132.55-6.84 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.4m-.85.5-1.62-.94m-61.53-46.38 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m851.47 1088.9 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 827.67 1100.379)"
      className={classes.st0}
      cx="827.63"
      cy="1100.79"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 827.67 1100.379)"
      className={classes.st0}
      cx="827.63"
      cy="1100.79"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m834.62 1092.09-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m835.73 1102.66-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m841.12 1096.74-6.83 3.95-1.67.02m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m789.18 1052.94 2.43 1.4-11.97 6.9-2.42-1.4zm-5.66-3.27 2.43 1.4-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 765.389 1064.438)"
      className={classes.st0}
      cx="765.34"
      cy="1064.83"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 765.389 1064.438)"
      className={classes.st0}
      cx="765.34"
      cy="1064.83"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m772.33 1056.12-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m773.44 1066.7-7.56 4.36-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m778.84 1060.78-6.84 3.94-1.66.03m12-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-62.11-46.72 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m726.57 1016.79 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 702.787 1028.311)"
      className={classes.st0}
      cx="702.74"
      cy="1028.68"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 702.787 1028.311)"
      className={classes.st0}
      cx="702.74"
      cy="1028.68"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m709.72 1019.98-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.46m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m710.83 1030.55-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m716.23 1024.63-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.5-1.62-.94m-61.63-46.44 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m664.44 980.92 2.43 1.4-11.97 6.91-2.42-1.41zm-5.66-3.27 2.42 1.4-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 640.66 992.46)"
      className={classes.st0}
      cx="640.6"
      cy="992.81"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 640.66 992.46)"
      className={classes.st0}
      cx="640.6"
      cy="992.81"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m647.59 984.1-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m648.7 994.68-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m654.09 988.76-6.83 3.95-1.67.02m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.71-46.49 19.42 11.22-20.51 11.84-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m602.23 945 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 578.454 956.56)"
      className={classes.st0}
      cx="578.39"
      cy="956.89"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 578.454 956.56)"
      className={classes.st0}
      cx="578.39"
      cy="956.89"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m585.38 948.19-3.24-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m586.49 958.76-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m591.88 952.84-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.73-46.49 19.42 11.21L531 923.61l-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m540 909.07 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 516.235 920.655)"
      className={classes.st0}
      cx="516.16"
      cy="920.96"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 516.235 920.655)"
      className={classes.st0}
      cx="516.16"
      cy="920.96"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m523.15 912.26-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m524.26 922.83-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m529.65 916.91-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.4m-.85.5-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m477.79 873.15 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 454.027 884.756)"
      className={classes.st0}
      cx="453.95"
      cy="885.05"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 454.027 884.756)"
      className={classes.st0}
      cx="453.95"
      cy="885.05"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m460.94 876.34-3.24-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.23 1.87-.82 2.35.8.47"
    />
    <path
      className={classes.st0}
      d="m462.05 886.91-7.57 4.37-11.32-6.54 7.56-4.37.13-.08-6.48-3.73 25.64-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m467.44 880.99-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.61-.94m-62.71-23.37-19.42-11.22 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m398.76 843.31-2.43-1.4 11.96-6.91 2.43 1.4zm5.66 3.27-2.43-1.4 11.97-6.91 2.42 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 422.67 831.147)"
      className={classes.st0}
      cx="422.59"
      cy="831.42"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 422.67 831.147)"
      className={classes.st0}
      cx="422.59"
      cy="831.42"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m415.61 840.12 3.23 1.87 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.97 2.43.81.47m-11.17-9.44-3.24-1.87-4.21.56-.81-.46m26.63-.42 6.83-3.95.05-.96m-14.91 1.13-3.23-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m414.5 829.55 7.56-4.36 11.33 6.54-7.57 4.36-.13.08 6.48 3.74-25.64 14.8-24.28-14.02 25.64-14.8 6.48 3.74z"
    />
    <path
      className={classes.st0}
      d="m409.1 835.47 6.84-3.95 1.66-.02m-12.01 7.86 2.43 1.41m-.9 1.45-2.43-1.4m.86-.49 1.62.93m-62.38-25.16-19.43-11.21 20.52-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m336.88 807.59-2.43-1.41 11.96-6.9 2.43 1.4zm5.66 3.27-2.43-1.41 11.97-6.9 2.42 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 360.794 795.441)"
      className={classes.st0}
      cx="360.71"
      cy="795.69"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 360.794 795.441)"
      className={classes.st0}
      cx="360.71"
      cy="795.69"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m353.73 804.4 3.23 1.87 4.11-.51.81.47m-18.46 4.12 3.24 1.86-.97 2.44.8.46m-11.16-9.44-3.24-1.87-4.21.57-.81-.47m26.62-.42 6.84-3.95.05-.96m-14.91 1.13-3.23-1.87.83-2.34-.81-.47"
    />
    <path
      className={classes.st0}
      d="m352.62 793.83 7.56-4.37L371.5 796l-7.56 4.37-.13.07 6.48 3.74-25.64 14.8-24.28-14.01 25.64-14.81 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m347.22 799.74 6.84-3.94 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.86-.49 1.61.93m678.69 314.87 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1031.88 1128.92 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1008.051 1140.352)"
      className={classes.st0}
      cx="1008.04"
      cy="1140.81"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1008.051 1140.352)"
      className={classes.st0}
      cx="1008.04"
      cy="1140.81"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1015.03 1132.1-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1016.14 1142.68-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1021.54 1136.76-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.33-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m969.05 1092.64 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 945.227 1104.097)"
      className={classes.st0}
      cx="945.21"
      cy="1104.53"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 945.227 1104.097)"
      className={classes.st0}
      cx="945.21"
      cy="1104.53"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m952.2 1095.83-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.41-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m953.31 1106.4-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m958.7 1100.48-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.4m-.85.5-1.62-.94m-61.53-46.38 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m907.02 1056.83 2.43 1.4-11.97 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 883.201 1068.304)"
      className={classes.st0}
      cx="883.18"
      cy="1068.72"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 883.201 1068.304)"
      className={classes.st0}
      cx="883.18"
      cy="1068.72"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m890.17 1060.01-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m891.28 1070.59-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m896.67 1064.67-6.83 3.95-1.67.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m844.73 1020.86 2.43 1.41-11.97 6.9-2.42-1.4zm-5.66-3.27 2.42 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 820.92 1032.363)"
      className={classes.st0}
      cx="820.89"
      cy="1032.76"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 820.92 1032.363)"
      className={classes.st0}
      cx="820.89"
      cy="1032.76"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m827.88 1024.05-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m828.99 1034.62-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m834.38 1028.71-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-62.11-46.72 19.42 11.22-20.51 11.84-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m782.12 984.72 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 758.317 996.237)"
      className={classes.st0}
      cx="758.28"
      cy="996.61"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 758.317 996.237)"
      className={classes.st0}
      cx="758.28"
      cy="996.61"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m765.27 987.91-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m766.38 998.48-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m771.78 992.56-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.63-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m719.99 948.84 2.43 1.41-11.97 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 696.19 960.384)"
      className={classes.st0}
      cx="696.15"
      cy="960.74"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 696.19 960.384)"
      className={classes.st0}
      cx="696.15"
      cy="960.74"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m703.14 952.03-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.24-1.86.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m704.25 962.6-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m709.64 956.69-6.83 3.94-1.67.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.71-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m657.78 912.93 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 633.984 924.486)"
      className={classes.st0}
      cx="633.94"
      cy="924.82"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 633.984 924.486)"
      className={classes.st0}
      cx="633.94"
      cy="924.82"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m640.93 916.11-3.24-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.82 2.35.8.46"
    />
    <path
      className={classes.st0}
      d="m642.04 926.69-7.57 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m647.43 920.77-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.73-46.49 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m595.55 877 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 571.764 888.58)"
      className={classes.st0}
      cx="571.71"
      cy="888.89"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 571.764 888.58)"
      className={classes.st0}
      cx="571.71"
      cy="888.89"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m578.7 880.19-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m579.81 890.76-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m585.2 884.84-6.83 3.95-1.67.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.5-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.43-11.21z"
    />
    <path
      className={classes.st0}
      d="m533.34 841.08 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 509.557 852.682)"
      className={classes.st0}
      cx="509.5"
      cy="852.97"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 509.557 852.682)"
      className={classes.st0}
      cx="509.5"
      cy="852.97"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m516.48 844.27-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.41-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m517.59 854.84-7.56 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m522.99 848.92-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.61-.94m-62.71-23.38-19.43-11.21 20.52-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m454.3 811.24-2.42-1.4 11.96-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.97-6.91 2.42 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 478.198 799.073)"
      className={classes.st0}
      cx="478.14"
      cy="799.35"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 478.198 799.073)"
      className={classes.st0}
      cx="478.14"
      cy="799.35"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m471.16 808.05 3.23 1.87 4.11-.5.81.47M460.85 814l3.24 1.87-.97 2.43.8.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.46m26.62-.42 6.84-3.95.05-.96m-14.91 1.13-3.23-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m470.05 797.48 7.56-4.36 11.32 6.54-7.56 4.36-.13.08 6.48 3.73-25.64 14.81-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m464.65 803.4 6.84-3.95 1.66-.02m-12.01 7.86 2.43 1.41m-.9 1.45-2.43-1.4m.86-.5 1.61.94m-62.38-25.16-19.42-11.21 20.51-11.85 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m392.42 775.51-2.42-1.4 11.96-6.91 2.43 1.41zm5.67 3.27-2.43-1.4 11.97-6.91 2.42 1.41z"
    />
    <ellipse
      transform="rotate(-2.688 416.325 763.366)"
      className={classes.st0}
      cx="416.26"
      cy="763.62"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 416.325 763.366)"
      className={classes.st0}
      cx="416.26"
      cy="763.62"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m409.27 772.33 3.24 1.86 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.57-.81-.47m26.62-.42 6.84-3.95.05-.96m-14.91 1.13-3.23-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m408.16 761.75 7.57-4.36 11.32 6.54-7.56 4.36-.13.08 6.48 3.74-25.64 14.8-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m402.77 767.67 6.84-3.95 1.66-.02m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.86-.49 1.61.93m678.69 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1087.43 1096.84 2.43 1.41-11.97 6.9-2.42-1.4zm-5.66-3.27 2.42 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1063.582 1108.277)"
      className={classes.st0}
      cx="1063.59"
      cy="1108.74"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1063.582 1108.277)"
      className={classes.st0}
      cx="1063.59"
      cy="1108.74"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1070.58 1100.03-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1071.69 1110.6-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1077.09 1104.69-6.84 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-62.33-46.85 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1024.6 1060.57 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1000.757 1072.022)"
      className={classes.st0}
      cx="1000.76"
      cy="1072.46"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1000.757 1072.022)"
      className={classes.st0}
      cx="1000.76"
      cy="1072.46"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1007.75 1063.76-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1008.86 1074.33-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1014.25 1068.41-6.83 3.95-1.67.02m12.01-7.86-2.42-1.41m.9-1.45 2.42 1.4m-.85.5-1.62-.94m-61.53-46.38 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m962.57 1024.75 2.43 1.41-11.97 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 938.731 1036.227)"
      className={classes.st0}
      cx="938.73"
      cy="1036.65"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 938.731 1036.227)"
      className={classes.st0}
      cx="938.73"
      cy="1036.65"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m945.72 1027.94-3.24-1.87-4.11.51-.8-.47m18.45-4.12-3.24-1.86.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m946.83 1038.51-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m952.22 1032.6-6.83 3.94-1.67.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m900.28 988.79 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 876.45 1000.287)"
      className={classes.st0}
      cx="876.44"
      cy="1000.69"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 876.45 1000.287)"
      className={classes.st0}
      cx="876.44"
      cy="1000.69"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m883.43 991.98-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.97m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m884.54 1002.55-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m889.93 996.64-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.93m-62.11-46.72 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m837.67 952.65 2.43 1.4-11.97 6.91-2.42-1.41zm-5.66-3.27 2.42 1.4-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 813.848 964.16)"
      className={classes.st0}
      cx="813.83"
      cy="964.54"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 813.848 964.16)"
      className={classes.st0}
      cx="813.83"
      cy="964.54"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m820.82 955.83-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m821.93 966.41-7.56 4.36-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m827.33 960.49-6.84 3.95-1.67.02m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.63-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m775.54 916.77 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 751.721 928.308)"
      className={classes.st0}
      cx="751.7"
      cy="928.67"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 751.721 928.308)"
      className={classes.st0}
      cx="751.7"
      cy="928.67"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m758.69 919.96-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m759.8 930.53-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m765.19 924.62-6.83 3.94-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.85.49-1.62-.93m-61.71-46.49 19.42 11.21-20.51 11.84-19.43-11.21z"
    />
    <path
      className={classes.st0}
      d="m713.33 880.85 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 689.515 892.411)"
      className={classes.st0}
      cx="689.49"
      cy="892.75"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 689.515 892.411)"
      className={classes.st0}
      cx="689.49"
      cy="892.75"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m696.47 884.04-3.23-1.87-4.11.51-.81-.47m18.46-4.12-3.24-1.86.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m697.58 894.61-7.56 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m702.98 888.7-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.73-46.5 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m651.1 844.93 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 627.294 856.504)"
      className={classes.st0}
      cx="627.26"
      cy="856.82"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 627.294 856.504)"
      className={classes.st0}
      cx="627.26"
      cy="856.82"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m634.25 848.12-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m635.36 858.69-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m640.75 852.77-6.83 3.95-1.67.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.72-46.49 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m588.88 809.01 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 565.088 820.605)"
      className={classes.st0}
      cx="565.05"
      cy="820.9"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 565.088 820.605)"
      className={classes.st0}
      cx="565.05"
      cy="820.9"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m572.03 812.2-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.8-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.63.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m573.14 822.77-7.56 4.36-11.33-6.54 7.57-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m578.54 816.85-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.5-1.62-.94m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m509.85 779.17-2.42-1.4 11.96-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.97-6.91 2.42 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 533.728 766.996)"
      className={classes.st0}
      cx="533.69"
      cy="767.28"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 533.728 766.996)"
      className={classes.st0}
      cx="533.69"
      cy="767.28"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m526.7 775.98 3.24 1.87 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.47m26.62-.42 6.84-3.94.05-.96m-14.91 1.13-3.23-1.87.82-2.35-.8-.47"
    />
    <path
      className={classes.st0}
      d="m525.59 765.41 7.57-4.37 11.32 6.55-7.56 4.36-.13.08 6.48 3.73-25.64 14.81-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m520.2 771.33 6.84-3.95 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.4m.86-.5 1.61.94m-62.38-25.16-19.42-11.22 20.51-11.84 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m447.97 743.44-2.42-1.4 11.96-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.41z"
    />
    <ellipse
      transform="rotate(-2.688 471.855 731.29)"
      className={classes.st0}
      cx="471.81"
      cy="731.55"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 471.855 731.29)"
      className={classes.st0}
      cx="471.81"
      cy="731.55"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m464.82 740.25 3.24 1.87 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.46m26.62-.42 6.84-3.95.05-.96m-14.91 1.13-3.24-1.87.83-2.35-.8-.46"
    />
    <path
      className={classes.st0}
      d="m463.71 729.68 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.48 3.74-25.64 14.8-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m458.32 735.6 6.84-3.95 1.66-.02m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.85-.49 1.62.93m678.69 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1142.98 1064.77 2.43 1.41-11.97 6.9-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1119.112 1076.202)"
      className={classes.st0}
      cx="1119.14"
      cy="1076.67"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1119.112 1076.202)"
      className={classes.st0}
      cx="1119.14"
      cy="1076.67"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1126.13 1067.96-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1127.24 1078.53-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1132.63 1072.62-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-62.33-46.85 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1080.15 1028.5 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1056.288 1039.945)"
      className={classes.st0}
      cx="1056.31"
      cy="1040.39"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1056.288 1039.945)"
      className={classes.st0}
      cx="1056.31"
      cy="1040.39"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1063.3 1031.69-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1064.41 1042.26-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1069.8 1036.34-6.83 3.95-1.67.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.53-46.38 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1018.12 992.68 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 994.262 1004.153)"
      className={classes.st0}
      cx="994.28"
      cy="1004.58"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 994.262 1004.153)"
      className={classes.st0}
      cx="994.28"
      cy="1004.58"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1001.27 995.87-3.24-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1002.38 1006.44-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1007.77 1000.53-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m955.83 956.72 2.43 1.4-11.97 6.91-2.43-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 931.98 968.212)"
      className={classes.st0}
      cx="931.99"
      cy="968.62"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 931.98 968.212)"
      className={classes.st0}
      cx="931.99"
      cy="968.62"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m938.98 959.91-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m940.09 970.48-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m945.48 964.56-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m893.22 920.57 2.43 1.41-11.97 6.9-2.42-1.4zm-5.66-3.27 2.42 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 869.378 932.085)"
      className={classes.st0}
      cx="869.38"
      cy="932.47"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 869.378 932.085)"
      className={classes.st0}
      cx="869.38"
      cy="932.47"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m876.37 923.76-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m877.48 934.33-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01L884.08 938l-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m882.87 928.42-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.63-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m831.09 884.7 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 807.251 896.233)"
      className={classes.st0}
      cx="807.25"
      cy="896.6"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 807.251 896.233)"
      className={classes.st0}
      cx="807.25"
      cy="896.6"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m814.24 887.89-3.24-1.87-4.11.5-.8-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m815.35 898.46-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m820.74 892.54-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.85.49-1.62-.94m-61.72-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m768.87 848.78 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 745.045 860.334)"
      className={classes.st0}
      cx="745.04"
      cy="860.68"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 745.045 860.334)"
      className={classes.st0}
      cx="745.04"
      cy="860.68"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m752.02 851.97-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.8-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.63.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m753.13 862.54-7.56 4.37-11.33-6.54 7.57-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m758.53 856.63-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.72-46.5 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m706.65 812.86 2.43 1.4-11.97 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 682.824 824.429)"
      className={classes.st0}
      cx="682.81"
      cy="824.75"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 682.824 824.429)"
      className={classes.st0}
      cx="682.81"
      cy="824.75"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m689.8 816.04-3.24-1.86-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m690.91 826.62-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m696.3 820.7-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.72-46.49 19.42 11.22-20.51 11.84-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m644.43 776.94 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 620.618 788.53)"
      className={classes.st0}
      cx="620.6"
      cy="788.83"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 620.618 788.53)"
      className={classes.st0}
      cx="620.6"
      cy="788.83"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m627.58 780.13-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.46m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m628.69 790.7-7.56 4.36-11.33-6.54 7.56-4.36.14-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m634.09 784.78-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m565.4 747.1-2.42-1.4 11.96-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 589.259 734.921)"
      className={classes.st0}
      cx="589.24"
      cy="735.2"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 589.259 734.921)"
      className={classes.st0}
      cx="589.24"
      cy="735.2"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m582.25 743.91 3.24 1.87 4.11-.5.81.46m-18.46 4.12 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.47m26.62-.42 6.84-3.94.05-.96m-14.91 1.13-3.24-1.87.83-2.35-.8-.47"
    />
    <path
      className={classes.st0}
      d="m581.14 733.34 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.48 3.74-25.64 14.8-24.28-14.01 25.64-14.8 6.47 3.73z"
    />
    <path
      className={classes.st0}
      d="m575.75 739.26 6.84-3.95 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.41m.85-.49 1.62.94m-62.38-25.16-19.42-11.22 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m503.52 711.37-2.42-1.4 11.96-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 527.386 699.215)"
      className={classes.st0}
      cx="527.36"
      cy="699.48"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 527.386 699.215)"
      className={classes.st0}
      cx="527.36"
      cy="699.48"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m520.37 708.18 3.24 1.87 4.11-.5.8.47m-18.45 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.46m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m519.26 697.61 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.63 14.8-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m513.87 703.53 6.84-3.95 1.66-.02m-12.01 7.86 2.43 1.41m-.9 1.45-2.43-1.4m.85-.5 1.62.94m678.69 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1198.53 1032.7 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1174.643 1044.125)"
      className={classes.st0}
      cx="1174.69"
      cy="1044.6"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1174.643 1044.125)"
      className={classes.st0}
      cx="1174.69"
      cy="1044.6"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1181.68 1035.89-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1182.79 1046.46-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1188.18 1040.54-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.94m-62.33-46.84 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1135.7 996.43 2.43 1.4-11.97 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1111.818 1007.87)"
      className={classes.st0}
      cx="1111.86"
      cy="1008.32"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1111.818 1007.87)"
      className={classes.st0}
      cx="1111.86"
      cy="1008.32"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1118.85 999.61-3.24-1.86-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1119.96 1010.19-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1125.35 1004.27-6.83 3.95-1.67.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.53-46.38 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1073.67 960.61 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1049.792 972.078)"
      className={classes.st0}
      cx="1049.83"
      cy="972.51"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1049.792 972.078)"
      className={classes.st0}
      cx="1049.83"
      cy="972.51"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1056.82 963.8-3.24-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.23 1.87-.82 2.35.8.47"
    />
    <path
      className={classes.st0}
      d="m1057.93 974.37-7.57 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1063.32 968.45-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.61-.94m-61.79-46.52 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1011.38 924.65 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 987.51 936.135)"
      className={classes.st0}
      cx="987.54"
      cy="936.54"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 987.51 936.135)"
      className={classes.st0}
      cx="987.54"
      cy="936.54"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m994.53 927.84-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.41-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m995.64 938.41-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1001.03 932.49-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m948.77 888.5 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 924.908 900.01)"
      className={classes.st0}
      cx="924.93"
      cy="900.4"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 924.908 900.01)"
      className={classes.st0}
      cx="924.93"
      cy="900.4"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m931.92 891.69-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m933.03 902.26-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m938.42 896.35-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.93m-61.63-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m886.64 852.63 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 862.782 864.158)"
      className={classes.st0}
      cx="862.8"
      cy="864.52"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 862.782 864.158)"
      className={classes.st0}
      cx="862.8"
      cy="864.52"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m869.79 855.82-3.24-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.24 1.87-.83 2.35.8.47"
    />
    <path
      className={classes.st0}
      d="m870.9 866.39-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m876.29 860.47-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-61.72-46.48 19.42 11.21-20.51 11.84L796 820.04z"
    />
    <path
      className={classes.st0}
      d="m824.42 816.71 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 800.576 828.26)"
      className={classes.st0}
      cx="800.59"
      cy="828.61"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 800.576 828.26)"
      className={classes.st0}
      cx="800.59"
      cy="828.61"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m807.57 819.9-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.47m-26.62.42-6.83 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m808.68 830.47-7.56 4.37-11.33-6.54 7.56-4.37.14-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m814.08 824.55-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.62-.94m-61.72-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m762.2 780.79 2.42 1.4-11.96 6.9-2.43-1.4zm-5.67-3.28 2.43 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 738.355 792.354)"
      className={classes.st0}
      cx="738.36"
      cy="792.68"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 738.355 792.354)"
      className={classes.st0}
      cx="738.36"
      cy="792.68"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m745.35 783.97-3.24-1.87-4.11.51-.81-.47m18.46-4.11-3.24-1.87.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.24 1.87-.83 2.34.8.47"
    />
    <path
      className={classes.st0}
      d="m746.46 794.54-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m751.85 788.63-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.72-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m699.98 744.87 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 676.149 756.456)"
      className={classes.st0}
      cx="676.14"
      cy="756.76"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 676.149 756.456)"
      className={classes.st0}
      cx="676.14"
      cy="756.76"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m683.13 748.05-3.23-1.86-4.11.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m684.24 758.63-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m689.64 752.71-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m620.95 715.03-2.43-1.4 11.97-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 644.79 702.844)"
      className={classes.st0}
      cx="644.79"
      cy="703.13"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 644.79 702.844)"
      className={classes.st0}
      cx="644.79"
      cy="703.13"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m637.8 711.84 3.24 1.87 4.11-.5.8.46m-18.45 4.12 3.24 1.87-.98 2.43.81.46m-11.16-9.43-3.24-1.87-4.21.56-.81-.47m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.86.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m636.69 701.27 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.63 14.8-24.28-14.01 25.64-14.81 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m631.3 707.18 6.84-3.94 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.85-.49 1.62.93m-62.38-25.16-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m559.07 679.3-2.43-1.4 11.97-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 582.916 667.138)"
      className={classes.st0}
      cx="582.91"
      cy="667.41"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 582.916 667.138)"
      className={classes.st0}
      cx="582.91"
      cy="667.41"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m575.92 676.11 3.24 1.87 4.1-.5.81.47m-18.45 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.47m26.62-.41 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m574.81 665.54 7.56-4.37 11.33 6.55-7.56 4.36-.13.08 6.47 3.73-25.63 14.81-24.28-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m569.42 671.46 6.83-3.95 1.67-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.4m.85-.5 1.62.94m678.69 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1254.08 1000.63 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1230.173 1012.05)"
      className={classes.st0}
      cx="1230.24"
      cy="1012.52"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1230.173 1012.05)"
      className={classes.st0}
      cx="1230.24"
      cy="1012.52"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1237.23 1003.82-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1238.34 1014.39-7.56 4.37-11.33-6.54 7.56-4.37.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1243.73 1008.47-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-62.33-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1191.25 964.35 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1167.349 975.796)"
      className={classes.st0}
      cx="1167.41"
      cy="976.25"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1167.349 975.796)"
      className={classes.st0}
      cx="1167.41"
      cy="976.25"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1174.4 967.54-3.24-1.87-4.11.51-.81-.47m18.46-4.12-3.24-1.86.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1175.51 978.11-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1180.9 972.2-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.53-46.38 19.42 11.21-20.51 11.84-19.43-11.21z"
    />
    <path
      className={classes.st0}
      d="m1129.22 928.54 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1105.323 940.001)"
      className={classes.st0}
      cx="1105.38"
      cy="940.44"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1105.323 940.001)"
      className={classes.st0}
      cx="1105.38"
      cy="940.44"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1112.36 931.73-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1113.47 942.3-7.56 4.37-11.32-6.54 7.56-4.37.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1118.87 936.38-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.61-.94m-61.79-46.53 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1066.93 892.58 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1043.041 904.06)"
      className={classes.st0}
      cx="1043.09"
      cy="904.47"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1043.041 904.06)"
      className={classes.st0}
      cx="1043.09"
      cy="904.47"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1050.08 895.77-3.24-1.87-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1051.19 906.34-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1056.58 900.42-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.5-1.62-.94m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1004.32 856.43 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 980.439 867.934)"
      className={classes.st0}
      cx="980.48"
      cy="868.33"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 980.439 867.934)"
      className={classes.st0}
      cx="980.48"
      cy="868.33"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m987.47 859.62-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m988.58 870.19-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m993.97 864.27-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.85.49-1.62-.94m-61.63-46.43 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m942.19 820.56 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 918.312 832.082)"
      className={classes.st0}
      cx="918.35"
      cy="832.45"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 918.312 832.082)"
      className={classes.st0}
      cx="918.35"
      cy="832.45"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m925.34 823.75-3.24-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m926.45 834.32-7.57 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m931.84 828.4-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.5-1.61-.94m-61.72-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m879.97 784.64 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 856.106 796.185)"
      className={classes.st0}
      cx="856.13"
      cy="796.53"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 856.106 796.185)"
      className={classes.st0}
      cx="856.13"
      cy="796.53"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m863.12 787.83-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.47m-26.62.42-6.83 3.94-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m864.23 798.4-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m869.63 792.48-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.72-46.49 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m817.75 748.71 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 793.885 760.278)"
      className={classes.st0}
      cx="793.91"
      cy="760.61"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 793.885 760.278)"
      className={classes.st0}
      cx="793.91"
      cy="760.61"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m800.9 751.9-3.24-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m802.01 762.47-7.57 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m807.4 756.56-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.72-46.49 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m755.53 712.79 2.43 1.41-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.41-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 731.679 724.379)"
      className={classes.st0}
      cx="731.69"
      cy="724.69"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 731.679 724.379)"
      className={classes.st0}
      cx="731.69"
      cy="724.69"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m738.68 715.98-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m739.79 726.55-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.63 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m745.19 720.64-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m676.5 682.96-2.43-1.41 11.97-6.9 2.43 1.4zm5.67 3.27-2.43-1.41 11.96-6.9 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 700.32 670.77)"
      className={classes.st0}
      cx="700.34"
      cy="671.06"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 700.32 670.77)"
      className={classes.st0}
      cx="700.34"
      cy="671.06"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m693.35 679.77 3.24 1.87 4.1-.51.81.47m-18.45 4.12 3.24 1.86-.98 2.44.81.46m-11.16-9.44-3.24-1.87-4.21.57-.81-.47m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.34-.81-.47"
    />
    <path
      className={classes.st0}
      d="m692.24 669.2 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.63 14.8L660 680.34l25.64-14.81 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m686.85 675.11 6.83-3.94 1.67-.03m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.85-.49 1.62.93m-62.38-25.16-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m614.62 647.23-2.43-1.4 11.97-6.91 2.43 1.4zm5.67 3.27-2.43-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 638.446 635.064)"
      className={classes.st0}
      cx="638.46"
      cy="635.33"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 638.446 635.064)"
      className={classes.st0}
      cx="638.46"
      cy="635.33"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m631.47 644.04 3.24 1.87 4.1-.5.81.46m-18.45 4.12 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.47m26.62-.42 6.84-3.94.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m630.36 633.47 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.01 25.64-14.8 6.47 3.73z"
    />
    <path
      className={classes.st0}
      d="m624.97 639.39 6.83-3.95 1.67-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.4m.85-.5 1.62.94m678.69 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1309.63 968.56 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1285.703 979.974)"
      className={classes.st0}
      cx="1285.79"
      cy="980.45"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1285.703 979.974)"
      className={classes.st0}
      cx="1285.79"
      cy="980.45"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1292.78 971.75-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1293.89 982.32-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1299.28 976.4-6.83 3.95-1.67.02m12.01-7.86-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-62.33-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1246.8 932.28 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1222.88 943.719)"
      className={classes.st0}
      cx="1222.96"
      cy="944.18"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1222.88 943.719)"
      className={classes.st0}
      cx="1222.96"
      cy="944.18"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1229.95 935.47-3.24-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.86-.82 2.35.8.47"
    />
    <path
      className={classes.st0}
      d="m1231.06 946.04-7.57 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1236.45 940.13-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.54-46.38 19.43 11.21-20.52 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1184.76 896.47 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1160.853 907.927)"
      className={classes.st0}
      cx="1160.93"
      cy="908.36"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1160.853 907.927)"
      className={classes.st0}
      cx="1160.93"
      cy="908.36"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1167.91 899.66-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.8-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1169.02 910.23-7.56 4.36-11.33-6.54 7.57-4.36.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1174.42 904.31-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.78-46.53 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1122.48 860.51 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1098.571 871.986)"
      className={classes.st0}
      cx="1098.64"
      cy="872.4"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1098.571 871.986)"
      className={classes.st0}
      cx="1098.64"
      cy="872.4"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1105.63 863.7-3.24-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1106.74 874.27-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1112.13 868.35-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1059.87 824.36 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1035.97 835.86)"
      className={classes.st0}
      cx="1036.03"
      cy="836.25"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1035.97 835.86)"
      className={classes.st0}
      cx="1036.03"
      cy="836.25"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1043.02 827.55-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1044.13 838.12-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1049.52 832.2-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.85.5-1.62-.94m-61.64-46.44 19.43 11.22-20.52 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m997.74 788.49 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 973.843 800.007)"
      className={classes.st0}
      cx="973.9"
      cy="800.38"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 973.843 800.007)"
      className={classes.st0}
      cx="973.9"
      cy="800.38"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m980.88 791.68-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.8-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m981.99 802.25-7.56 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m987.39 796.33-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.72-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m935.52 752.57 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 911.637 764.108)"
      className={classes.st0}
      cx="911.68"
      cy="764.46"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 911.637 764.108)"
      className={classes.st0}
      cx="911.68"
      cy="764.46"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m918.67 755.76-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m919.78 766.33-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m925.18 760.41-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.5-1.62-.94m-61.73-46.49 19.43 11.21-20.52 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m873.3 716.64 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 849.416 728.203)"
      className={classes.st0}
      cx="849.46"
      cy="728.54"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 849.416 728.203)"
      className={classes.st0}
      cx="849.46"
      cy="728.54"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m856.44 719.83-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.8-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.12 3.23 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m857.55 730.4-7.56 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m862.95 724.48-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.61-.94m-61.72-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m811.08 680.72 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 787.21 692.304)"
      className={classes.st0}
      cx="787.24"
      cy="692.62"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 787.21 692.304)"
      className={classes.st0}
      cx="787.24"
      cy="692.62"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m794.23 683.91-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.17 9.43 3.23 1.87 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m795.34 694.48-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m800.74 688.57-6.84 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.85 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m732.05 650.88-2.43-1.4 11.97-6.91 2.43 1.41zm5.67 3.27-2.43-1.4 11.96-6.9 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 755.85 638.695)"
      className={classes.st0}
      cx="755.89"
      cy="638.99"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 755.85 638.695)"
      className={classes.st0}
      cx="755.89"
      cy="638.99"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m748.9 647.7 3.24 1.86 4.1-.5.81.47m-18.45 4.11 3.24 1.87-.98 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.57-.81-.47m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m747.79 637.12 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.64 14.8-24.27-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m742.4 643.04 6.83-3.95 1.67-.02m-12.01 7.87 2.43 1.4m-.9 1.45-2.43-1.4m.85-.49 1.62.93m-62.38-25.16-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m670.17 615.16-2.43-1.4 11.97-6.91 2.42 1.4zm5.66 3.27-2.42-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 693.977 602.989)"
      className={classes.st0}
      cx="694.01"
      cy="603.26"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 693.977 602.989)"
      className={classes.st0}
      cx="694.01"
      cy="603.26"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m687.02 611.97 3.24 1.87 4.1-.5.81.46m-18.45 4.12 3.23 1.87-.97 2.43.81.46m-11.16-9.43-3.24-1.87-4.21.56-.81-.47m26.62-.42 6.84-3.94.04-.97m-14.9 1.13-3.24-1.86.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m685.91 601.4 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.01 25.64-14.8 6.47 3.73z"
    />
    <path
      className={classes.st0}
      d="m680.52 607.32 6.83-3.95 1.67-.03m-12.01 7.87 2.42 1.4m-.9 1.46-2.42-1.41m.85-.49 1.62.93m678.69 314.87 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1365.18 936.49 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1341.234 947.9)"
      className={classes.st0}
      cx="1341.34"
      cy="948.38"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1341.234 947.9)"
      className={classes.st0}
      cx="1341.34"
      cy="948.38"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1348.33 939.68-3.24-1.87-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1349.44 950.25-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1354.83 944.33-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-62.33-46.84 19.42 11.21-20.51 11.84-19.43-11.21z"
    />
    <path
      className={classes.st0}
      d="m1302.35 900.21 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1278.41 911.644)"
      className={classes.st0}
      cx="1278.51"
      cy="912.11"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1278.41 911.644)"
      className={classes.st0}
      cx="1278.51"
      cy="912.11"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1285.49 903.4-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1286.6 913.97-7.56 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1292 908.05-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.61-.94m-61.54-46.38 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1240.31 864.4 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1216.384 875.85)"
      className={classes.st0}
      cx="1216.48"
      cy="876.29"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1216.384 875.85)"
      className={classes.st0}
      cx="1216.48"
      cy="876.29"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1223.46 867.59-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.46m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1224.57 878.16-7.56 4.36-11.33-6.54 7.56-4.36.14-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1229.97 872.24-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.78-46.53 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1178.03 828.44 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1154.102 839.909)"
      className={classes.st0}
      cx="1154.19"
      cy="840.33"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1154.102 839.909)"
      className={classes.st0}
      cx="1154.19"
      cy="840.33"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1161.18 831.62-3.24-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.82 2.35.8.46"
    />
    <path
      className={classes.st0}
      d="m1162.29 842.2-7.57 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1167.68 836.28-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1115.42 792.29 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1091.5 803.782)"
      className={classes.st0}
      cx="1091.58"
      cy="804.18"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1091.5 803.782)"
      className={classes.st0}
      cx="1091.58"
      cy="804.18"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1098.57 795.48-3.24-1.87-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1099.68 806.05-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1105.07 800.13-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.5-1.62-.94m-61.64-46.44 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1053.28 756.42 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1029.373 767.93)"
      className={classes.st0}
      cx="1029.45"
      cy="768.31"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1029.373 767.93)"
      className={classes.st0}
      cx="1029.45"
      cy="768.31"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1036.43 759.6-3.23-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.24 1.87 4.21-.57.81.47m-26.63.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1037.54 770.18-7.56 4.36-11.33-6.54 7.57-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1042.94 764.26-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.71-46.49 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m991.07 720.5 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 967.167 732.034)"
      className={classes.st0}
      cx="967.23"
      cy="732.39"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 967.167 732.034)"
      className={classes.st0}
      cx="967.23"
      cy="732.39"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m974.22 723.69-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m975.33 734.26-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m980.73 728.34-6.84 3.95-1.67.02m12.01-7.86-2.42-1.41m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.73-46.49 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m928.84 684.57 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 904.946 696.126)"
      className={classes.st0}
      cx="905.01"
      cy="696.47"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 904.946 696.126)"
      className={classes.st0}
      cx="905.01"
      cy="696.47"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m911.99 687.76-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.24 1.87 4.21-.56.81.47m-26.63.42-6.83 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m913.1 698.33-7.56 4.37-11.33-6.54 7.57-4.37.13-.08-6.48-3.73 25.64-14.8 24.28 14.01-25.64 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m918.5 692.41-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m866.63 648.65 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 842.74 660.227)"
      className={classes.st0}
      cx="842.79"
      cy="660.55"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 842.74 660.227)"
      className={classes.st0}
      cx="842.79"
      cy="660.55"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m849.78 651.84-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m850.89 662.41-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m856.28 656.49-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.94m-62.71-23.37-19.42-11.22 20.51-11.84 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m787.6 618.81-2.43-1.4 11.97-6.91 2.42 1.41zm5.66 3.27-2.42-1.4 11.96-6.91 2.43 1.41z"
    />
    <ellipse
      transform="rotate(-2.688 811.38 606.618)"
      className={classes.st0}
      cx="811.44"
      cy="606.92"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 811.38 606.618)"
      className={classes.st0}
      cx="811.44"
      cy="606.92"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m804.45 615.62 3.24 1.87 4.1-.5.81.47m-18.45 4.11 3.23 1.87-.97 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.46m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m803.34 605.05 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.64 14.8-24.27-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m797.95 610.97 6.83-3.95 1.67-.02m-12.01 7.87 2.42 1.4m-.9 1.45-2.42-1.4m.85-.49 1.62.93m-62.38-25.16-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m725.72 583.09-2.43-1.41 11.97-6.9 2.42 1.4zm5.66 3.27-2.42-1.41 11.96-6.9 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 749.507 570.912)"
      className={classes.st0}
      cx="749.56"
      cy="571.19"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 749.507 570.912)"
      className={classes.st0}
      cx="749.56"
      cy="571.19"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m742.57 579.9 3.24 1.87 4.1-.51.81.47m-18.45 4.12 3.23 1.86-.97 2.44.81.46m-11.16-9.44-3.24-1.86-4.21.56-.81-.47m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.34-.81-.47"
    />
    <path
      className={classes.st0}
      d="m741.46 569.33 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.01 25.64-14.81 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m736.07 575.24 6.83-3.94 1.67-.03m-12.01 7.87 2.42 1.4m-.9 1.45-2.42-1.4m.85-.49 1.62.93m678.69 314.87 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1420.73 904.42 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1396.764 915.825)"
      className={classes.st0}
      cx="1396.89"
      cy="916.31"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1396.764 915.825)"
      className={classes.st0}
      cx="1396.89"
      cy="916.31"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1403.88 907.6-3.24-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.24 1.87-.83 2.35.8.46"
    />
    <path
      className={classes.st0}
      d="m1404.99 918.18-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1410.38 912.26-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-62.34-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1357.89 868.14 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1333.938 879.57)"
      className={classes.st0}
      cx="1334.06"
      cy="880.03"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1333.938 879.57)"
      className={classes.st0}
      cx="1334.06"
      cy="880.03"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1341.04 871.33-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.8-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1342.15 881.9-7.56 4.37-11.33-6.54 7.57-4.37.13-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m1347.55 875.98-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.53-46.38 19.42 11.22-20.51 11.84-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1295.86 832.33 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1271.914 843.775)"
      className={classes.st0}
      cx="1272.03"
      cy="844.22"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1271.914 843.775)"
      className={classes.st0}
      cx="1272.03"
      cy="844.22"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1279.01 835.52-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1280.12 846.09-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1285.52 840.17-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.78-46.53 19.42 11.21-20.51 11.84-19.43-11.21z"
    />
    <path
      className={classes.st0}
      d="m1233.58 796.36 2.42 1.41-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1209.632 807.834)"
      className={classes.st0}
      cx="1209.74"
      cy="808.26"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1209.632 807.834)"
      className={classes.st0}
      cx="1209.74"
      cy="808.26"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1216.72 799.55-3.23-1.87-4.11.51-.81-.47m18.46-4.12-3.24-1.86.98-2.44-.81-.46m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1217.83 810.12-7.56 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1223.23 804.21-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-62.11-46.72 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1170.97 760.22 2.42 1.4-11.96 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1147.03 771.708)"
      className={classes.st0}
      cx="1147.13"
      cy="772.11"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1147.03 771.708)"
      className={classes.st0}
      cx="1147.13"
      cy="772.11"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1154.12 763.41-3.24-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.24 1.87-.83 2.35.8.46"
    />
    <path
      className={classes.st0}
      d="m1155.23 773.98-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1160.62 768.06-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.64-46.44 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1108.83 724.35 2.43 1.4-11.96 6.9-2.43-1.4zm-5.66-3.28 2.43 1.41-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1084.904 735.855)"
      className={classes.st0}
      cx="1085"
      cy="736.24"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1084.904 735.855)"
      className={classes.st0}
      cx="1085"
      cy="736.24"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1091.98 727.53-3.23-1.87-4.11.51-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.57.8.47m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1093.09 738.1-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1098.49 732.19-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.71-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1046.62 688.43 2.43 1.4-11.97 6.91-2.42-1.41zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1022.697 699.957)"
      className={classes.st0}
      cx="1022.78"
      cy="700.32"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1022.697 699.957)"
      className={classes.st0}
      cx="1022.78"
      cy="700.32"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1029.77 691.61-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1030.88 702.19-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1036.27 696.27-6.83 3.95-1.67.02m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.73-46.49 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m984.39 652.5 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 960.477 664.051)"
      className={classes.st0}
      cx="960.56"
      cy="664.39"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 960.477 664.051)"
      className={classes.st0}
      cx="960.56"
      cy="664.39"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m967.54 655.69-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.46m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m968.65 666.26-7.56 4.36-11.33-6.54 7.56-4.36.14-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m974.05 660.34-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m922.18 616.58 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 898.27 628.153)"
      className={classes.st0}
      cx="898.34"
      cy="628.47"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 898.27 628.153)"
      className={classes.st0}
      cx="898.34"
      cy="628.47"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m905.33 619.77-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m906.44 630.34-7.56 4.37-11.33-6.55 7.56-4.36.13-.08-6.47-3.73 25.64-14.81 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m911.83 624.42-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.4m-.85.5-1.62-.94m-62.71-23.37-19.42-11.22 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m843.15 586.74-2.43-1.4 11.97-6.91 2.42 1.4zm5.66 3.27-2.42-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 866.91 574.544)"
      className={classes.st0}
      cx="866.99"
      cy="574.85"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 866.91 574.544)"
      className={classes.st0}
      cx="866.99"
      cy="574.85"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m860 583.55 3.24 1.87 4.1-.5.81.47m-18.45 4.11 3.23 1.87-.97 2.43.81.47m-11.16-9.44-3.24-1.87-4.21.56-.81-.46m26.62-.42 6.84-3.95.04-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m858.89 572.98 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.64 14.8-24.27-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m853.5 578.9 6.83-3.95 1.67-.02m-12.01 7.86 2.42 1.41m-.9 1.45-2.42-1.4m.85-.5 1.62.94m-62.38-25.16-19.42-11.21 20.51-11.85 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m781.27 551.01-2.43-1.4 11.97-6.9 2.42 1.4zm5.66 3.27-2.42-1.4 11.96-6.9 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 805.038 538.837)"
      className={classes.st0}
      cx="805.11"
      cy="539.12"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 805.038 538.837)"
      className={classes.st0}
      cx="805.11"
      cy="539.12"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m798.12 547.83 3.24 1.87 4.1-.51.81.47m-18.45 4.11 3.23 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.21.57-.81-.47m26.62-.42 6.83-3.95.05-.96m-14.9 1.13-3.24-1.87.83-2.34-.81-.47"
    />
    <path
      className={classes.st0}
      d="m797.01 537.25 7.56-4.36 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.02 25.64-14.8 6.47 3.74z"
    />
    <path
      className={classes.st0}
      d="m791.61 543.17 6.84-3.94 1.67-.03m-12.01 7.87 2.42 1.4m-.9 1.45-2.42-1.4m.85-.49 1.62.93m678.69 314.87 19.42 11.21-20.51 11.85-19.43-11.22z"
    />
    <path
      className={classes.st0}
      d="m1476.28 872.35 2.42 1.4-11.96 6.9-2.43-1.4zm-5.67-3.27 2.43 1.4-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1452.295 883.748)"
      className={classes.st0}
      cx="1452.44"
      cy="884.24"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1452.295 883.748)"
      className={classes.st0}
      cx="1452.44"
      cy="884.24"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1459.43 875.53-3.24-1.87-4.11.51-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1460.54 886.11-7.57 4.36-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1465.93 880.19-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-62.34-46.84 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1413.44 836.07 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1389.468 847.493)"
      className={classes.st0}
      cx="1389.61"
      cy="847.96"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1389.468 847.493)"
      className={classes.st0}
      cx="1389.61"
      cy="847.96"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1396.59 839.26-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.46m-26.62.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1397.7 849.83-7.56 4.36-11.33-6.54 7.56-4.36.14-.08-6.48-3.73 25.64-14.81 24.28 14.02-25.64 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1403.1 843.91-6.84 3.95-1.66.02m12.01-7.86-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-61.53-46.38 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1351.41 800.26 2.43 1.4-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1327.444 811.7)"
      className={classes.st0}
      cx="1327.57"
      cy="812.15"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1327.444 811.7)"
      className={classes.st0}
      cx="1327.57"
      cy="812.15"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1334.56 803.44-3.24-1.87-4.1.51-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1335.67 814.02-7.56 4.36-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1341.07 808.1-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1289.12 764.29 2.43 1.41-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1265.163 775.758)"
      className={classes.st0}
      cx="1265.29"
      cy="776.19"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1265.163 775.758)"
      className={classes.st0}
      cx="1265.29"
      cy="776.19"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1272.27 767.48-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.8-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.63.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1273.38 778.05-7.56 4.37-11.33-6.54 7.57-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1278.78 772.14-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-62.1-46.72 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1226.52 728.15 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.97 6.91-2.42-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1202.56 739.633)"
      className={classes.st0}
      cx="1202.68"
      cy="740.04"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1202.56 739.633)"
      className={classes.st0}
      cx="1202.68"
      cy="740.04"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1209.67 731.33-3.24-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1210.78 741.91-7.57 4.36-11.32-6.54 7.56-4.36.13-.08-6.48-3.74 25.64-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1216.17 735.99-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.64-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1164.38 692.27 2.43 1.41-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.41-11.97 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1140.434 703.78)"
      className={classes.st0}
      cx="1140.54"
      cy="704.17"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1140.434 703.78)"
      className={classes.st0}
      cx="1140.54"
      cy="704.17"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1147.53 695.46-3.23-1.87-4.11.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.17 9.44 3.23 1.86 4.21-.56.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1148.64 706.03-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.63 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1154.04 700.12-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.71-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1102.17 656.36 2.43 1.4-11.97 6.9-2.42-1.4zm-5.66-3.28 2.42 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1078.228 667.882)"
      className={classes.st0}
      cx="1078.33"
      cy="668.25"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1078.228 667.882)"
      className={classes.st0}
      cx="1078.33"
      cy="668.25"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1085.32 659.54-3.24-1.87-4.1.51-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1086.43 670.11-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1091.82 664.2-6.83 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.73-46.5 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1039.94 620.43 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1016.007 631.977)"
      className={classes.st0}
      cx="1016.1"
      cy="632.32"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1016.007 631.977)"
      className={classes.st0}
      cx="1016.1"
      cy="632.32"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1023.09 623.62-3.23-1.87-4.11.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1024.2 634.19-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1029.6 628.27-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.5-1.62-.94M969.82 576l19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m977.73 584.51 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 953.8 596.078)"
      className={classes.st0}
      cx="953.89"
      cy="596.4"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 953.8 596.078)"
      className={classes.st0}
      cx="953.89"
      cy="596.4"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m960.88 587.7-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m961.99 598.27-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.73 25.63-14.81 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m967.38 592.35-6.83 3.95-1.67.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.5-1.62-.94m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m898.7 554.67-2.43-1.4 11.97-6.91 2.42 1.4zm5.66 3.27-2.42-1.4 11.96-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 922.441 542.469)"
      className={classes.st0}
      cx="922.54"
      cy="542.78"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 922.441 542.469)"
      className={classes.st0}
      cx="922.54"
      cy="542.78"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m915.55 551.48 3.24 1.87 4.1-.5.81.47m-18.45 4.11 3.23 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.21.56-.81-.47m26.62-.41 6.83-3.95.05-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m914.44 540.91 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.73-25.64 14.81-24.27-14.02 25.63-14.8 6.48 3.74z"
    />
    <path
      className={classes.st0}
      d="m909.04 546.83 6.84-3.95 1.67-.03m-12.01 7.87 2.42 1.4m-.9 1.46-2.42-1.4m.85-.5 1.62.94m-62.38-25.16-19.42-11.22 20.51-11.84 19.42 11.22z"
    />
    <path
      className={classes.st0}
      d="m836.82 518.94-2.43-1.4 11.96-6.91 2.43 1.41zm5.66 3.27-2.43-1.4 11.97-6.91 2.43 1.41z"
    />
    <ellipse
      transform="rotate(-2.688 860.568 506.76)"
      className={classes.st0}
      cx="860.66"
      cy="507.05"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 860.568 506.76)"
      className={classes.st0}
      cx="860.66"
      cy="507.05"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m853.67 515.76 3.24 1.86 4.1-.5.81.47m-18.45 4.11 3.23 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.21.57-.81-.47m26.62-.42 6.83-3.95.05-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m852.56 505.18 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.64 14.8-24.27-14.02 25.63-14.8 6.48 3.74z"
    />
    <path
      className={classes.st0}
      d="m847.16 511.1 6.84-3.95 1.66-.02M843.65 515l2.43 1.4m-.9 1.45-2.43-1.4m.86-.49 1.62.93m678.68 314.87 19.43 11.21-20.52 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1531.82 840.27 2.43 1.41-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1507.825 851.673)"
      className={classes.st0}
      cx="1507.99"
      cy="852.17"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1507.825 851.673)"
      className={classes.st0}
      cx="1507.99"
      cy="852.17"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1514.97 843.46-3.23-1.87-4.11.51-.81-.47m18.46-4.12-3.24-1.86.97-2.44-.8-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1516.08 854.03-7.56 4.37-11.33-6.54 7.57-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1521.48 848.12-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-62.34-46.85 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1468.99 804 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1444.999 815.418)"
      className={classes.st0}
      cx="1445.16"
      cy="815.89"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1444.999 815.418)"
      className={classes.st0}
      cx="1445.16"
      cy="815.89"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1452.14 807.19-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.46m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1453.25 817.76-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1458.65 811.84-6.84 3.95-1.66.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.53-46.38 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1406.96 768.18 2.43 1.41-11.97 6.9-2.42-1.4zm-5.66-3.27 2.42 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1382.975 779.624)"
      className={classes.st0}
      cx="1383.12"
      cy="780.08"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1382.975 779.624)"
      className={classes.st0}
      cx="1383.12"
      cy="780.08"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1390.11 771.37-3.24-1.87-4.1.51-.81-.47m18.45-4.12-3.23-1.86.97-2.44-.81-.46m11.17 9.44 3.23 1.86 4.21-.56.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1391.22 781.94-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.63 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1396.62 776.03-6.84 3.94-1.67.03m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1344.67 732.22 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1320.693 743.683)"
      className={classes.st0}
      cx="1320.84"
      cy="744.12"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1320.693 743.683)"
      className={classes.st0}
      cx="1320.84"
      cy="744.12"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1327.82 735.41-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.22-.56.8.47m-26.62.42-6.83 3.94-.05.96m14.91-1.13 3.23 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1328.93 745.98-7.56 4.37-11.33-6.54 7.56-4.37.14-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m1334.33 740.06-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.62-.94m-62.11-46.71 19.43 11.21-20.52 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1282.07 696.08 2.42 1.4-11.96 6.9-2.43-1.4zm-5.67-3.28 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1258.091 707.556)"
      className={classes.st0}
      cx="1258.23"
      cy="707.97"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1258.091 707.556)"
      className={classes.st0}
      cx="1258.23"
      cy="707.97"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1265.21 699.26-3.23-1.87-4.11.51-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.8-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1266.32 709.83-7.56 4.37-11.32-6.54 7.56-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1271.72 703.92-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.61-.93m-61.64-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1219.93 660.2 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1195.964 671.704)"
      className={classes.st0}
      cx="1196.09"
      cy="672.1"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1195.964 671.704)"
      className={classes.st0}
      cx="1196.09"
      cy="672.1"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1203.08 663.39-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.17 9.43 3.23 1.87 4.21-.56.81.47m-26.62.42-6.83 3.94-.05.96m14.9-1.12 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1204.19 673.96-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.63 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m1209.59 668.04-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1157.72 624.28 2.43 1.41-11.97 6.9-2.43-1.4zm-5.67-3.27 2.43 1.41-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1133.758 635.808)"
      className={classes.st0}
      cx="1133.88"
      cy="636.18"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1133.758 635.808)"
      className={classes.st0}
      cx="1133.88"
      cy="636.18"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1140.87 627.47-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.44 3.24 1.86 4.21-.56.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1141.98 638.04-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.81-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1147.37 632.13-6.83 3.94-1.67.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-61.73-46.5 19.42 11.22-20.51 11.84-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1095.49 588.36 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1071.537 599.9)"
      className={classes.st0}
      cx="1071.65"
      cy="600.25"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1071.537 599.9)"
      className={classes.st0}
      cx="1071.65"
      cy="600.25"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1078.64 591.55-3.24-1.87-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1079.75 602.12-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1085.15 596.2-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.71-46.49 19.42 11.22-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1033.28 552.44 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1009.331 564.001)"
      className={classes.st0}
      cx="1009.44"
      cy="564.33"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1009.331 564.001)"
      className={classes.st0}
      cx="1009.44"
      cy="564.33"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1016.43 555.63-3.24-1.87-4.11.5-.8-.47m18.45-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.56.81.46m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1017.54 566.2-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1022.93 560.28-6.83 3.95-1.67.02m12.01-7.86-2.43-1.41m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m954.25 522.6-2.43-1.4 11.96-6.91 2.43 1.4zm5.66 3.27-2.43-1.4 11.97-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 977.972 510.392)"
      className={classes.st0}
      cx="978.09"
      cy="510.7"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 977.972 510.392)"
      className={classes.st0}
      cx="978.09"
      cy="510.7"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m971.1 519.41 3.23 1.87 4.11-.5.81.46m-18.45 4.12 3.23 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.21.56-.81-.47m26.62-.42 6.83-3.94.05-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m969.99 508.84 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.01 25.63-14.8 6.48 3.73z"
    />
    <path
      className={classes.st0}
      d="m964.59 514.76 6.84-3.95 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.4m.86-.5 1.62.94m-62.38-25.16-19.42-11.22 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m892.37 486.87-2.43-1.4 11.96-6.91 2.43 1.4zm5.66 3.27-2.43-1.4 11.97-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 916.099 474.686)"
      className={classes.st0}
      cx="916.2"
      cy="474.98"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 916.099 474.686)"
      className={classes.st0}
      cx="916.2"
      cy="474.98"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m909.22 483.68 3.23 1.87 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.21.56-.81-.46m26.62-.42 6.83-3.95.05-.96m-14.9 1.13-3.24-1.87.83-2.35-.81-.46"
    />
    <path
      className={classes.st0}
      d="m908.11 473.11 7.56-4.36 11.33 6.54-7.56 4.36-.13.08 6.47 3.74-25.64 14.8-24.27-14.02 25.63-14.8 6.48 3.74z"
    />
    <path
      className={classes.st0}
      d="m902.71 479.03 6.84-3.95 1.66-.02m-12.01 7.86 2.43 1.41m-.9 1.45-2.43-1.4m.86-.49 1.62.93m678.68 314.87 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1587.37 808.2 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1563.355 819.596)"
      className={classes.st0}
      cx="1563.54"
      cy="820.1"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1563.355 819.596)"
      className={classes.st0}
      cx="1563.54"
      cy="820.1"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1570.52 811.39-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.81-.46m11.17 9.43 3.23 1.87 4.22-.56.81.47m-26.63.42-6.83 3.94-.05.97m14.91-1.13 3.23 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1571.63 821.96-7.56 4.37-11.33-6.54 7.56-4.37.14-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m1577.03 816.04-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.86.49-1.62-.93m-62.33-46.85 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1524.54 771.93 2.43 1.4-11.96 6.91-2.43-1.41zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1500.53 783.341)"
      className={classes.st0}
      cx="1500.7"
      cy="783.82"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1500.53 783.341)"
      className={classes.st0}
      cx="1500.7"
      cy="783.82"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1507.69 775.11-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.83 3.95-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1508.8 785.69-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.64-14.8 24.27 14.02-25.63 14.8-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1514.2 779.77-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.53-46.38 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1462.51 736.11 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1438.505 747.549)"
      className={classes.st0}
      cx="1438.67"
      cy="748.01"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1438.505 747.549)"
      className={classes.st0}
      cx="1438.67"
      cy="748.01"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1445.66 739.3-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.97m14.9-1.13 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1446.77 749.87-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1452.16 743.95-6.83 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.41m-.85.49-1.62-.93m-61.79-46.53 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1400.22 700.15 2.43 1.4-11.96 6.91-2.43-1.4zm-5.66-3.27 2.43 1.4-11.97 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1376.224 711.608)"
      className={classes.st0}
      cx="1376.38"
      cy="712.05"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1376.224 711.608)"
      className={classes.st0}
      cx="1376.38"
      cy="712.05"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1383.37 703.34-3.23-1.87-4.11.5-.81-.47m18.46-4.11-3.24-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.47m-26.62.42-6.83 3.94-.05.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1384.48 713.91-7.56 4.37-11.33-6.54 7.56-4.37.13-.08-6.47-3.73 25.64-14.8 24.27 14.01-25.63 14.8-6.48-3.73z"
    />
    <path
      className={classes.st0}
      d="m1389.88 707.99-6.84 3.95-1.66.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.4m-.86.5-1.62-.94m-62.11-46.71 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1337.61 664 2.43 1.41-11.96 6.9-2.43-1.4zm-5.66-3.27 2.43 1.41-11.97 6.9-2.42-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1313.621 675.482)"
      className={classes.st0}
      cx="1313.78"
      cy="675.9"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1313.621 675.482)"
      className={classes.st0}
      cx="1313.78"
      cy="675.9"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1320.76 667.19-3.23-1.87-4.11.5-.81-.46m18.46-4.12-3.24-1.87.97-2.43-.81-.46m11.17 9.44 3.24 1.86 4.21-.56.81.47m-26.63.42-6.83 3.95-.05.96m14.91-1.13 3.23 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1321.87 677.76-7.56 4.37-11.33-6.54 7.57-4.37.13-.07-6.48-3.74 25.64-14.8 24.28 14.01-25.64 14.81-6.48-3.74z"
    />
    <path
      className={classes.st0}
      d="m1327.27 671.85-6.84 3.94-1.66.03m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.86.49-1.62-.93m-61.63-46.44 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1275.48 628.13 2.43 1.4-11.97 6.91-2.42-1.4zm-5.66-3.27 2.42 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1251.495 639.63)"
      className={classes.st0}
      cx="1251.64"
      cy="640.03"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1251.495 639.63)"
      className={classes.st0}
      cx="1251.64"
      cy="640.03"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1258.63 631.32-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1259.74 641.89-7.56 4.37-11.33-6.54 7.56-4.37.13-.08-6.47-3.73 25.64-14.8 24.27 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1265.14 635.97-6.84 3.95-1.67.03m12.01-7.87-2.42-1.4m.9-1.46 2.42 1.4m-.85.5-1.62-.94m-61.71-46.48 19.42 11.21-20.51 11.84-19.42-11.21z"
    />
    <path
      className={classes.st0}
      d="m1213.27 592.21 2.43 1.4-11.97 6.91-2.43-1.4zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1189.289 603.73)"
      className={classes.st0}
      cx="1189.43"
      cy="604.11"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1189.289 603.73)"
      className={classes.st0}
      cx="1189.43"
      cy="604.11"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1196.42 595.4-3.24-1.87-4.1.5-.81-.46m18.45-4.12-3.24-1.87.98-2.43-.81-.46m11.16 9.43 3.24 1.87 4.21-.56.81.47m-26.62.42-6.84 3.94-.04.96m14.9-1.12 3.24 1.86-.83 2.35.81.47"
    />
    <path
      className={classes.st0}
      d="m1197.53 605.97-7.56 4.37-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.63-14.8 24.28 14.01-25.64 14.8-6.47-3.73z"
    />
    <path
      className={classes.st0}
      d="m1202.92 600.05-6.83 3.95-1.67.03m12.01-7.87-2.43-1.4m.9-1.46 2.43 1.41m-.85.49-1.62-.94m-61.73-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1151.04 556.29 2.43 1.4-11.97 6.91-2.42-1.41zm-5.66-3.27 2.42 1.4-11.96 6.9-2.43-1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1127.068 567.825)"
      className={classes.st0}
      cx="1127.2"
      cy="568.18"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1127.068 567.825)"
      className={classes.st0}
      cx="1127.2"
      cy="568.18"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1134.19 559.47-3.24-1.86-4.1.5-.81-.47m18.45-4.11-3.23-1.87.97-2.43-.81-.47m11.17 9.44 3.23 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.34.81.47"
    />
    <path
      className={classes.st0}
      d="m1135.3 570.05-7.56 4.36-11.33-6.54 7.56-4.37.13-.07-6.47-3.74 25.64-14.8 24.27 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1140.7 564.13-6.84 3.95-1.67.02m12.01-7.87-2.42-1.4m.9-1.45 2.42 1.4m-.85.49-1.62-.93m-61.71-46.49 19.42 11.21-20.51 11.85-19.42-11.22z"
    />
    <path
      className={classes.st0}
      d="m1088.83 520.37 2.42 1.4-11.96 6.91-2.43-1.41zm-5.67-3.27 2.43 1.4-11.96 6.91-2.43-1.41z"
    />
    <ellipse
      transform="rotate(-2.688 1064.862 531.927)"
      className={classes.st0}
      cx="1064.99"
      cy="532.26"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1064.862 531.927)"
      className={classes.st0}
      cx="1064.99"
      cy="532.26"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1071.98 523.55-3.24-1.86-4.11.5-.81-.47m18.46-4.11-3.24-1.87.98-2.43-.81-.47m11.16 9.44 3.24 1.87 4.21-.57.81.47m-26.62.42-6.84 3.95-.04.96m14.9-1.13 3.24 1.87-.83 2.35.81.46"
    />
    <path
      className={classes.st0}
      d="m1073.09 534.13-7.56 4.36-11.33-6.54 7.56-4.36.13-.08-6.47-3.74 25.63-14.8 24.28 14.02-25.64 14.8-6.47-3.74z"
    />
    <path
      className={classes.st0}
      d="m1078.48 528.21-6.84 3.95-1.66.02m12.01-7.87-2.43-1.4m.9-1.45 2.43 1.4m-.85.49-1.62-.93m-62.71-23.38-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m1009.8 490.53-2.43-1.4 11.96-6.91 2.43 1.4zm5.66 3.27-2.43-1.4 11.97-6.91 2.43 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 1033.502 478.317)"
      className={classes.st0}
      cx="1033.63"
      cy="478.63"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 1033.502 478.317)"
      className={classes.st0}
      cx="1033.63"
      cy="478.63"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m1026.65 487.34 3.23 1.87 4.11-.5.81.46m-18.46 4.12 3.24 1.87-.97 2.43.81.46m-11.17-9.43-3.23-1.87-4.22.56-.8-.47m26.62-.42 6.83-3.94.05-.97m-14.91 1.13-3.23-1.86.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m1025.54 476.77 7.56-4.37 11.33 6.54-7.56 4.37-.13.07 6.47 3.74-25.64 14.8-24.27-14.01 25.63-14.8 6.48 3.73z"
    />
    <path
      className={classes.st0}
      d="m1020.14 482.69 6.84-3.95 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.41m.86-.49 1.62.94m-62.38-25.17-19.42-11.21 20.51-11.84 19.42 11.21z"
    />
    <path
      className={classes.st0}
      d="m947.92 454.8-2.43-1.4 11.96-6.91 2.43 1.4zm5.66 3.27-2.43-1.4 11.97-6.91 2.42 1.4z"
    />
    <ellipse
      transform="rotate(-2.688 971.629 442.611)"
      className={classes.st0}
      cx="971.75"
      cy="442.91"
      rx="4.71"
      ry="2.71"
    />
    <ellipse
      transform="rotate(-2.688 971.629 442.611)"
      className={classes.st0}
      cx="971.75"
      cy="442.91"
      rx="2.36"
      ry="1.36"
    />
    <path
      className={classes.st0}
      d="m964.77 451.61 3.23 1.87 4.11-.5.81.47m-18.46 4.11 3.24 1.87-.97 2.43.81.47m-11.17-9.44-3.23-1.87-4.22.56-.8-.46m26.62-.42 6.83-3.95.05-.96m-14.91 1.13-3.23-1.87.83-2.35-.81-.47"
    />
    <path
      className={classes.st0}
      d="m963.66 441.04 7.56-4.36 11.33 6.54-7.56 4.36-.14.08 6.48 3.73-25.64 14.81-24.28-14.02 25.64-14.8 6.48 3.74z"
    />
    <path
      className={classes.st0}
      d="m958.26 446.96 6.84-3.95 1.66-.03m-12.01 7.87 2.43 1.4m-.9 1.46-2.43-1.4m.86-.5 1.62.94"
    />
  </svg>
);

export default QubitsImage;
